// extracted by mini-css-extract-plugin
export var contrastLow = "_2i-1";
export var externalLink = "_2i-2";
export var externalLinkIcon = "_2i-3";
export var link = "_2i-0";
export var linkLabel = "_2i-4";